import Vue from 'vue';
import store from '@/store';

const { isApp, isIosApp, isAndroidApp } = store.getters.platform;

Vue.prototype.$webridge = {
    showLoadingControl() {
        jsToNative('CommonUI', 'loadingControl', { loading: true, error: false });
    },
    hideLoadingControl() {
        if (isAndroidApp) {
            jsToNative('CommonUI', 'loadingControl', { loading: false, error: false });
        } else if (isIosApp) {
            window._native_response_finish = true;
            window._ios_or_response_finish('接口');
        }
    }
};


function jsToNative(handler, action, params = {}) {
    if (isApp) {
        webridge.jsToNative({ handler, action, params });
    }
}

/*
* 作用 比较两个版本号的大小
* 条件: 版本号是以.分割的 子版本号的级数可以不一致
* @param firstVersion 第一个参数
* @param secondeVersion 第二个参数
* @return number 如果返回1表示前者大于后者, -1表示小于，0表示相等
* */
export function versionJudge ( firstVersion, secondVersion ){
    var result = 0 ;
    var firstArr = firstVersion.split(".") ;
    var secondArr = secondVersion.split(".") ;
    var firstArrLen = firstArr.length ;
    var secondArrLen = secondArr.length ;

    //级数是否相等
    var hasEqualLen = ( firstArrLen == secondArrLen ) ;

    //需要对比判断的级数
    var compareLen ;
    if( hasEqualLen ) {
        compareLen = firstArrLen ;
    } else {
        compareLen = Math.min(firstArrLen, secondArrLen);
    }

    //判断级数相等的部分
    for( var i = 0 ; i < compareLen ; i ++ ) {
        if( parseInt( firstArr[i] ) == parseInt( secondArr[i]) ) {
            continue ;
        } else {
            result = parseInt( firstArr[i] ) > parseInt( secondArr[i] ) ? 1 : -1;
            break ;
        }
    }

    //判断级数不等的部分
    if( result == 0 && !hasEqualLen ) result = firstArrLen > secondArrLen ? 1 : -1 ;

    return result ;
};

export function handleUserInfo(cb) {
    //app相关信息
    webridge.jsToNative({
        handler: 'Common',
        action: 'commonStatus',
        callback: function(response){
            let res = JSON.parse(response);
            store.commit('SET_APP_INFO', res)
        }
    })
    //查看app状态SET_DEFAULT
    webridge.jsToNative({
        handler: 'Common',
        action: 'loginStatus',
        callback: function(result) {
            if (result === 'true' || result === '1') {
                webridge.jsToNative({
                    handler: 'UserInfo',
                    action: 'getUserInformation',
                    callback: function(result) {
                        let res = JSON.parse(result);
                        store.commit('SET_LOGIN_SUCCESS', res.usertoken);
                        store.commit('SET_USER', res.userinfo);
                        store.commit('filter/SET_DEFAULT', 0, {root: true})
                        store.commit('SET_ARCHIVE_ID', res.archiveid);
                        console.log('DEBUG_LOG:set archive id bridge', res.archiveid);
                        cb && cb();
                    }
                });
            }else{
                store.commit('SET_LOGOUT');
                cb && cb();
            }
        }
    });

    // 检查是否安装微信
    webridge.jsToNative({
        handler: 'Common',
        action: 'wxHasInstalled',
        callback: function(response){
            store.commit('SET_WX_INSTALLED', response)
        }
    })
}

export function webLoadFinish() {
    if (isIosApp) {
        jsToNative('Common', 'webLoadFinish');
    } else if (isAndroidApp) {
        window.onCheckPageAlive = () => {
            return true;
        };
    }
}

/**
 * 获取设备信息
 */
 export function handleDeviceInfo() {
    //app相关信息
    webridge.jsToNative({
        handler: 'Common',
        action: 'getDeviceInfo',
        callback: function(response){
            let res = JSON.parse(response);
            console.log('resdbhsd',res);
            store.commit('SET_DEVICE_INFO', res)
        }
    }) 
}

export function eventBridgeInit() {
    jsToNative('Core', 'eventBridgeInit', { eventDispatchFunction: 'eventDispatchFunction' });
    window['eventDispatchFunction'] = function(event, result) {
        if (window[event]) {
            window[event](result);
        } else {
            console.log(`${event} -- 未找到该方法`);
        }
    };
}

export function hideLoadingControl() {
    jsToNative('CommonUI', 'loadingControl', { loading: false, error: false });
}

export function getAppStorage(key_, cb) {
    webridge.jsToNative({
        handler: 'Storage',
        action: 'getValueByKey',
        params: {
            name: key_
        },
        callback: function(res){
            cb && cb(res)
        }
    });
}

/**
 * @param {*} cb
 */
export function getAppExamineStatus(cb) {
    if(versionJudge (store.getters.appInfo.app_v, '2.5.0.0')  > 0 ){
        webridge.jsToNative({
            handler: 'BuyCourse',
            action: 'getExamine',
            callback: function(params){
                let test = {
                    code: 200,
                    data: JSON.parse(params)
                }
                cb && cb(test)
            }
        });

    }else{
        let test = {
            code: 500
        }
        cb && cb(test)
    }
}


export function isAppInstalled(appUrl, cb) {
    webridge.jsToNative({
        handler: 'App',
        action: 'isAppInstalled',
        params: {
            scheme: appUrl
        },
        callback: function(params){
            let res = JSON.parse(params).isAppInstalled;

            cb && cb(res)
        }
    });
}

